import React, { useState, useMemo } from 'react';
import { FaCaretDown, FaCaretRight } from 'react-icons/fa';

import { TeamProgressBlock } from './TeamProgressBlock';
import './OfficersBlock.css';

const safeDecode = (text) => {
    try {
        return decodeURIComponent(text);
    } catch (e) {
        return text;
    }
};

const getCsvData = (answers, teamId) => {
    let maxQuestionCount = 0; // for csv data sheet column amount
    // Add safety check for answers.logs
    if (answers && answers.logs && Array.isArray(answers.logs)) {
        answers.logs.forEach(l => {
            if (l.answers && l.answers.length > maxQuestionCount) maxQuestionCount = l.answers.length;
        });
    }
    let questionCaptions = [];
    for (let i = 0; i < maxQuestionCount; i++)
        questionCaptions.push("question " + (i + 1));

    let csvData = [];
    csvData.push([
        "date", "email", "lesson",
        "experience", "quiz", ...questionCaptions, "platform"
    ]);

    if (answers && answers.logs && Array.isArray(answers.logs)) {
        answers.logs.forEach(l => {
            if (l.teamId !== teamId) {
                return;
            }

            let line = [];
            line.push(l.date); line.push(l.email);
            line.push(l.lessonName); line.push(l.experienceName);
            line.push(`${l.quizName} (${l.quizId})`);
            for (let i = 0; i < maxQuestionCount; i++) {
                const answerCell = l.answers && l.answers[i] !== undefined ? l.answers[i] : "";
                line.push(answerCell);
            }

            line.push(l.platform);

            csvData.push(line);
        });
    }

    return csvData;
}

export const OfficersBlock = ({ officers, answers }) => {
    const [selectedOfficerId, setSelectedOfficerId] = useState(null);
    const officersCsvData = useMemo(() => (
        officers.reduce((acc, officer) => {
            // Add safety check for officer.teams
            if (officer.teams && Array.isArray(officer.teams)) {
                officer.teams.forEach(team => {
                    acc[team.id] = getCsvData(answers, team.id);
                });
            }

            return acc;
        }, {})
    ), [officers]);

    const toggleCollapse = (officerId) => {
        setSelectedOfficerId(selectedOfficerId === officerId ? null : officerId);
    };

    return officers?.map(officer => {
        const isSelected = selectedOfficerId === officer.id;
        // Add safety checks for officer.teams
        const teams = officer.teams || [];
        const activeTeams = teams.filter(team => team.active).length;
        const activeLessons = teams.reduce((acc, team) => {
            return acc + (team.lessons ? team.lessons.length : 0);
        } , 0);

        return (
            <div key={officer.id} className="officers-block">
                <div
                    className="officers-block-header mb-1"
                    onClick={() => toggleCollapse(officer.id)}>
                    {isSelected ? <FaCaretDown /> : <FaCaretRight />}
                    <span className="ml-1">{officer.email}</span>
                    <div className="ml-auto">
                        <span className="mr-3"><span className="font-weight-bold">Active teams </span>{activeTeams}</span>
                        <span><span className="font-weight-bold">Active lessons </span>{activeLessons}</span>
                    </div>
                </div>
                {
                    isSelected ?
                        teams.map((team, index) => {
                            return (
                                <TeamProgressBlock
                                    key={team.id}
                                    {...team}
                                    isLast={index === teams.length - 1}
                                    csvData={officersCsvData[team.id]}
                                />
                            );
                        })
                    :
                    null
                }
            </div>
        );
    });
}
